export default "__VITE_ASSET__TOEg6clY__"